const BU_STATUS_FILTER = [
  { text: 'Archived', value: 'archived' },
  { text: 'Active', value: 'active' },
];
export default BU_STATUS_FILTER;



// WEBPACK FOOTER //
// ./src/constants/businessUnitStatusFilter.js